import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const IntegrationsSettingsSection: React.FC = () => (
  <SettingsHubSection section="integrations" />
);

export default IntegrationsSettingsSection;
